import * as kitTypesService from '../../../services/KitTypes/kitTypesService.js';
import * as batchJobsService from '../../../services/BatchJobs/batchJobsService.js';
import * as daHelper from '../dialogActionsHelper';
import { api as messageDialogApi } from '../../MessageDialog/messageDialogActions';
import {dialogsNames} from '../../../enums/dialogsNames';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Network from 'infrastructure/js/modules/network';

const config = {
  getSubmitMethod: (submitConfigData) => {
    return submitConfigData?.isMultiKitTypes ?
      kitTypesService.updateWorkOrdersMultiKitTypesVersions : kitTypesService.updateWorkOrdersKitTypeVersion;
  },
  onNotValidResponse: (response) => {
    if (response?.status !== 304) {
      return null;
    }
    const labels = createLabelHelper('mat.administration.matsettings.dialog.updatekitTypeVersion.');
    return {
      title: labels.get('schedulerRunning'),
      className: 'oneBackground',
      type: 'warning',
    };
  },
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG),
};

export let api = {
  ...daHelper.getApiActions(actions, config),

  // The multi-kit-types submit (workorders/change-multi-kittypes) now runs as an async batch job -
  // the initial response only confirms the job started, it is not the final result. Stay on this
  // same dialog (busy/disabled, with an overlay spinner) and poll the job directly instead of
  // handing off to BatchJobsActions.runJob's separate progress dialog. Once the job completes, close
  // this dialog and show the same confirmation-summary message dialog as the single-kit-type path,
  // fed with the job's real success/total counts.
  submitMultiKitTypes: function (dispatch, getState) {
    return function (data, messageDialogBuilder, reloadParentComponent) {
      dispatch(actions.setBusy(true));

      return kitTypesService.updateWorkOrdersMultiKitTypesVersions(data)
        .then((response) => {
          if (!Network.isResponseValid(response)) {
            console.error('updateWorkOrdersMultiKitTypesVersions failed ', response);
            dispatch(actions.setBusy(false));
            messageDialogApi.responseError(dispatch, getState)(response);
            return response;
          }

          return batchJobsService.pollingResult(response.data.jobExecutionId, {})
            .then((pollResponse) => {
              dispatch(actions.setBusy(false));
              dispatch(actions.hide());

              if (reloadParentComponent) {
                reloadParentComponent();
              }

              if (messageDialogBuilder && pollResponse?.data) {
                let messageDialogDescriptor = messageDialogBuilder(pollResponse.data, messageDialogApi.close(dispatch, getState));
                messageDialogApi.open(dispatch, getState)(messageDialogDescriptor);
              }

              return pollResponse;
            })
            .catch((error) => {
              console.error('updateWorkOrdersMultiKitTypesVersions polling failed ', error);
              dispatch(actions.setBusy(false));
              messageDialogApi.showError(dispatch, getState)();
            });
        })
        .catch((error) => {
          console.error('updateWorkOrdersMultiKitTypesVersions failed, catch error: ', error);
          dispatch(actions.setBusy(false));
        });
    }.bind(this);
  },
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

  submit: function (data, messageDialogBuilder, reloadParentComponent, submitConfigData = null) {
    return function (dispatch, getState) {
      if (submitConfigData?.isMultiKitTypes) {
        return api.submitMultiKitTypes(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent);
      }
      return api.submit(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent, submitConfigData);
    };
  },
};
